<template>
  <div id="benchView">
    <menu-top></menu-top>
    <side-menu-page-list></side-menu-page-list>
    <side-menu-toolbox></side-menu-toolbox>

    <page-background></page-background>
    <page-fields></page-fields>
    <drag-index v-if="$store.state.dragIndex"></drag-index>
    <multiple-select v-if="$store.state.multipleSelect"></multiple-select>
    <modal-dialog></modal-dialog>
    <multiple-select-dialog></multiple-select-dialog>
    <modal-edit-field></modal-edit-field>
    <modal-template-editor></modal-template-editor>
    <modal-add-template></modal-add-template>
    <modal-duplicate-template></modal-duplicate-template>
    <modal-delete-template></modal-delete-template>

    <annotations></annotations>
    <global-tooltip></global-tooltip>
    <menu-bottom></menu-bottom>
    <notifications></notifications>
    <!-- <time-travel></time-travel> -->
  </div>
</template>

<script>
  import MenuTop from '@/components/editor/main/MenuTop'
  import GlobalTooltip from '@/components/editor/main/GlobalTooltip'
  import MenuBottom from '@/components/editor/main/MenuBottom'
  import SideMenuPageList from '@/components/editor/main/SideMenuPageList'
  import SideMenuToolbox from '@/components/editor/main/SideMenuToolbox'
  import Annotations from '@/components/editor/main/Annotations'
  import TimeTravel from '@/components/editor/TimeTravel'

  import PageBackground from '@/components/editor/main/PageBackground'
  import PageFields from '@/components/editor/main/PageFields'
  import DragIndex from '@/components/editor/main/DragIndex'
  import MultipleSelect from '@/components/editor/main/MultipleSelect'
  import ModalDialog from '@/components/editor/modals/ModalDialog'
  import MultipleSelectDialog from '@/components/editor/modals/MultipleSelectDialog'
  import ModalAddTemplate from '@/components/editor/modals/ModalAddTemplate'
  import ModalDuplicateTemplate from '@/components/editor/modals/ModalDuplicateTemplate'
  import ModalDeleteTemplate from '@/components/editor/modals/ModalDeleteTemplate'
  import ModalEditField from '@/components/editor/modal-edit/ModalEditField'
  import ModalTemplateEditor from '@/components/editor/modals/ModalTemplateEditor'
  import Notifications from '@/components/editor/main/Notifications'

  export default {
    name: 'editor-view',

    components: {
      MenuTop,
      GlobalTooltip,
      MenuBottom,
      SideMenuPageList,
      SideMenuToolbox,
      Annotations,
      TimeTravel,

      PageBackground,
      PageFields,
      DragIndex,
      MultipleSelect,
      ModalDialog,
      MultipleSelectDialog,
      ModalAddTemplate,
      ModalDuplicateTemplate,
      ModalDeleteTemplate,
      ModalEditField,
      ModalTemplateEditor,
      Notifications
    },

    methods: {
      handleMouseDown (e) {
        if (e.keyCode === 83 && (navigator.platform.match('Mac') ? e.metaKey : e.ctrlKey)) {
          e.preventDefault()
          this.$bus.emit('saveTriggered')
        }
      }
    },

    mounted () {
      document.addEventListener('keydown', this.handleMouseDown, false)
    },

    beforeDestroy () {
      document.removeEventListener('keydown', this.handleMouseDown, false)
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/EditorView.vue